import { Product } from "models/product";
export function formatResults(data, quarters) {
  let result = [];
  var products_names = [];
  const q1 = quarters[0];
  const q2 = quarters[1];
  const q3 = quarters[2];
  const q4 = quarters[3];

  // get all products list
  data.forEach((elem, index) => {
    // The only way to identify product is using the productName. There are no Ids.
    // e.g. "productName": "INNOSURE - VACUNA PORCINOS - CONJUGADO DE GNRF MODIFICADO, TOXOIDE DE DIFTERIA - FRASCO - 125 DOSIS",

    const product_splited_values = elem.productName.split("-");

    // the value of the original producName will be set in the description field
    data[index]["description"] = elem.productName;

    // a new product name is shorter for better understanding
    data[index].productName =
      product_splited_values[0].trim() +
      "-" +
      product_splited_values[product_splited_values.length - 1].trim();

    // a list with all the prodcutNames is created to be used as filter in order to find values per quarter by each product
    if (!products_names.includes(elem.productName)) {
      products_names.push(elem.productName);
    }
  });

  products_names.sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1));

  // cheking each product name in the list to collect the values by quarters
  products_names.forEach((name) => {
    var temp_product = new Product();

    data.forEach((row) => {
      if (row.productName === name) {
        temp_product.category = row.productCategory;
        temp_product.laboratory = row.productManufacturer;
        temp_product.name = row.productName;
        temp_product.presentation = row.productPresentation;
        temp_product.description = row.description;
        if (row.quarterId === q1) {
          temp_product.quarter1Quantity = row.totalQuantity;
          temp_product.quarter1Sales = row.totalSales;
        }
        if (row.quarterId === q2) {
          temp_product.quarter2Quantity = row.totalQuantity;
          temp_product.quarter2Sales = row.totalSales;
        }
        if (row.quarterId === q3) {
          temp_product.quarter3Quantity = row.totalQuantity;
          temp_product.quarter3Sales = row.totalSales;
        }
        if (row.quarterId === q4) {
          temp_product.quarter4Quantity = row.totalQuantity;
          temp_product.quarter4Sales = row.totalSales;
        }
      }
    });

    result.push(temp_product);
  });
  return result;
}
